export default __webpack_public_path__ + "35d2923b65df24e09bfd82b9d3f6accc.png";